import { buildSchema } from 'graphql';

export const SANDBOX_EMPTY_SCHEMA = buildSchema('type Query { id: String }');
